export default class Footer {
    constructor() {
        this.init()
    }

    init() {
        this.footer = document.querySelector('.footer--default')
        this.cursor = document.querySelector('.cursor')
    }

    initCursor() {
        if (this.footer) {
            this.footer.addEventListener('mouseenter', () => {
                this.cursor.classList.add('color--white')
            })

            this.footer.addEventListener('mouseleave', () => {
                this.cursor.classList.remove('color--white')
            })
        }
    }
}
